import React from 'react';
import './login.css';
import BETO from '../../img/beto.jpg';
import LOGO from '../../img/foco90.svg';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import {WS_PAGAMENTO} from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import Modal from '../../components/modal.v2/Modal';
import ModalOverlay from '../../components/modal/Modal';
import EsqueceuSenha from './EsqueceuSenha';
import Pagamento from '../pagamento/Pagamento';
import Beto from '../../img/betoIntro.png';
import Cadastro from '../cadastro/Cadastro';
import FbPixel from '../fbPixel/FbPixel';
import PASSO1 from '../../img/tutorial-01.jpg';
import PASSO2 from '../../img/tutorial-02.jpg';
import PASSO3 from '../../img/tutorial-03.jpg';
import PASSO4 from '../../img/tutorial-04.jpg';
import CryptoJS from 'crypto-js';
import { KEY, IV } from '../../config/Commons';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import DAYS from './../../data/Days';
import ONDE_TREINA from './../../data/Onde_treina';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';
import TIPOS_PLANILHA from './../../data/TiposPlanilha';
import Objetivo from '../perfil/Objetivo';

const URL = 'https://pagamento.foco90.com.br';
const URL_ENTRAR = WS.entrar;
const URL_LOGIN = WS.login;
const URL_LOGGED = WS.checkLogged;


class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false,
      email: '',
      nome: '',
      sexo: 'F',
      step: 2,
      statusTutorial: true
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openEsqueceuSenha = this.openEsqueceuSenha.bind(this);
    this.openPagamento = this.openPagamento.bind(this);
    this.signin = this.signin.bind(this);
    this.removeTutorial = this.removeTutorial.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.backStep = this.backStep.bind(this);
    this.openObjetivo = this.openObjetivo.bind(this);
  }

  componentDidMount(){
    const self = this;
    var usuario = window.localStorage.getItem('usuario');
    var senha = window.localStorage.getItem('senha');

    //FbPixel.init();

    /*if(usuario && senha){
      this.setState({
        email: usuario,
        senha: senha,
        statusTutorial: false
      });
      this.makeLogin({email: usuario, senha: senha});
    }*/

    /*Requisitions({
      url: URL_LOGGED,
      data: {},
      sucess:function(data){
        if(data.status){
          window.dadosUser = data.user;
          self.props.history.push('/area-restrita/meu-treino/');
        }
      },
      error:function(data){
      }
    });*/
  }

  openObjetivo(e) {
    var modal = new ModalOverlay();
    modal.open({page:<Objetivo modal={modal} />});

    e.preventDefault();
  }

  signin(e){
    e.preventDefault();

    Modal.create({
      content: <Cadastro
      history={this.props.history} />
    });
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;

    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  handleSelect(__args__){
    let statusOt = (__args__.name === 'onde_treina' && __args__.value === 'casa');

    //previne que o select de O que procura?* apareça ao usar outro select
    if(this.state.statusOt && !statusOt && __args__.name !== 'onde_treina' ){
      statusOt = true;
    }

    this.setState({[__args__.name]:__args__.value, statusOt});
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.makeLogin();
  }

  openPagamento(){

    const key = CryptoJS.enc.Hex.parse(KEY);
    const iv = CryptoJS.enc.Hex.parse(IV);

    //npm install --save @types/crypto-js
    //npm i -S crypto-js
    //----------
    const secret = JSON.stringify(this.state.dataUserLogin);
    let encrypted = CryptoJS.AES.encrypt(secret, key, { iv });
    encrypted = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    let decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    const obj = JSON.parse(decrypted);
    //?u=5pRA3OoRDB1gb5YtnQ7/6jpcNVlRGpsEwbYPldDS5lkJWAG15XgsCP9qSVQhskxL
    //----------
    const url = `${URL}?u=${encrypted}`;

    window.open(url, '_blank');

  }

  openEsqueceuSenha(e){
    e.preventDefault();

    Modal.create({
      content: <EsqueceuSenha />,
    classes: 'box-esqueceu-senha'
    });
  }

  static setDataUser(args){
    if(args.sexo) window.localStorage.setItem('sexo', args.sexo);
    if(args.nome) window.localStorage.setItem('nome', args.nome);
    if(args.email) window.localStorage.setItem('email', args.email);
    if(args.onde_treina) window.localStorage.setItem('onde_treina', args.onde_treina);
    if(args.tipo_treino) window.localStorage.setItem('tipo_treino', args.tipo_treino);
    if(args.qtd_dias) window.localStorage.setItem('qtd_dias', args.qtd_dias);
    window.dadosUser = args;
  }

  makeLogin(){
    const {nome,email} = this.state;

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar
    }
    = this.state.strings;

    if(!nome && !email){
      var msg = {
        title: atencao,
        text: 'Digite o nome e o email'
      };

      Dialog.create(msg);
      return false;
    }else{
      Requisitions({
        url: URL_LOGIN,
        data: {nome,email},
        sucess:function(data){
          if(data.status){
            self.setState({dadosTreino: true});
            Login.setDataUser({nome,email});
            //self.props.history.push('/area-restrita/meu-treino/');
          }else{
            var msg = {
              title: atencao,
              text: data.msg
            };
            Dialog.create(msg);
          }
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroLogar
          });
        }
      });
    }
  }

  getTutorial(){
    return (
      <div className='tutorial'>
        <div className='tutorial__wrapper'>
          <div className='tutorial__inner'>
            <div className='tutorial__box'>
              <a href='#' onClick={this.removeTutorial}  className='bt-close-tutorial'><i className="fas fa-times"></i></a>
              <div className="box-login-logo"><img src={LOGO} /></div>
              <p className='tutorial__title'>Como instalar o app Foco90 no seu iPhone</p>
              <div className='tutorial__passo'>
                <img src={PASSO1} />
                <strong>Passo 1</strong>
                <p>Abra o <span className='strong'>Safari</span> no seu iphone e clique no ícone mostrado logo acima</p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO2} />
                <strong>Passo 2</strong>
                <p>Deslize os botões até encontrar o botão <span className='strong'>Tela de início</span> ou <span className='strong'>Add to Home Screen</span></p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO3} />
                <strong>Passo 3</strong>
                <p>Toque em <span className='strong'>Adicionar</span> ou <span className='strong'>Add</span></p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO4} />
                <strong>Passo 4</strong>
                <p>Pronto, agora você tem o seu app <span className='strong'>Foco90</span> instalado</p>
              </div>
              <div className='tutorial__box-button'><Button onClick={this.removeTutorial} type="button" text="Fechar" classes="button-login simple-button" /></div>

            </div>


          </div>
        </div>
      </div>
    );
  }

  removeTutorial(e){
    this.setState({
      statusTutorial: false
    });
    e.preventDefault();
  }

  changeStep(e){
    this.setState({step:2});
    e.preventDefault();
  }

  backStep(e){
    this.setState({step:1});
    e.preventDefault();
  }

  getStep1(){
    return <div className="box-center-button"><br />
      <div><br />
        <Button onClick={this.signin} type="button" text="Testar grátis" classes="button-login simple-button bounce" />
      </div>
        <br />
        <div>
          <Button type="button" text="Já sou cliente" onClick={this.changeStep} classes="button-outline simple-button" /></div>
        <div>
          <br />
        <a href='#' className='bt-not-signedin' onClick={this.openEsqueceuSenha}>Esqueceu sua senha?</a>
        <br />
      </div>
    </div>;
  }

  getStep2(){
    return <div>
      <div>
        <TextInput value={this.state.nome} onChange={this.handleInputChange} name="nome" title="Nome" placeholder="Digite seu nome"></TextInput>
        <TextInput value={this.state.email} onChange={this.handleInputChange} name="email" type="mail" title="Email" placeholder="Digite a email"></TextInput>
      </div><br />
    <div  className="box-center-button">
      <Button type="submit" text="Continuar" classes="button-login simple-button" />
      {/*<a href='#' className='no-underline' onClick={this.backStep}>Voltar</a>*/}

    </div>

    </div>;

  }

  getDadosLogin(){
    const boxStep = this.state.step == 1 ? this.getStep1() : this.getStep2();

    return (
      <form className="form-login"  onSubmit={this.handleSubmit}>
        <div className='hello-beto'>Olá, sou <strong>Roberto Jacob</strong><br />seu personal trainer</div>
        <br /><br /><br />
        {
          boxStep
        }
      </form>
    )
  }

  iniciarApp(e){
    e.preventDefault();

    const self = this;
    const {sexo,onde_treina,qtd_dias,tipo_treino, email} = this.state;

    if(!sexo){
      var msg = {
        title: 'Atenção',
        text: 'Escolha o sexo'
      };
      Dialog.create(msg);
      return false;
    }

    if(!onde_treina){
      var msg = {
        title: 'Atenção',
        text: 'Escolha onde irá treinar'
      };
      Dialog.create(msg);
      return false;
    }

    if(!qtd_dias){
      var msg = {
        title: 'Atenção',
        text: 'Escolha a quantidade de dias que irá treinar'
      };
      Dialog.create(msg);
      return false;
    }

    if(!tipo_treino && !this.state.statusOt){
      var msg = {
        title: 'Atenção',
        text: 'Escolha o tipo de treino'
      };
      Dialog.create(msg);
      return false;
    }

    Login.setDataUser({sexo,onde_treina,qtd_dias,tipo_treino, email});
    self.props.history.push({pathname:'/area-restrita/meu-treino/', state:{sexo,onde_treina,qtd_dias,tipo_treino, email}});

    /*Requisitions({
      url: URL_ENTRAR,
      data: {sexo,onde_treina,qtd_dias,tipo_treino, email},
      sucess:function(data){
        if(data.status){
          Login.setDataUser({sexo,onde_treina,qtd_dias,tipo_treino, email});
          //self.props.history.push('/area-restrita/meu-treino/');
        }else{
          var msg = {
            title: 'Atenção',
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: 'Atenção',
          text: 'Ocorreu um erro ao acessar o app (1001)'
        });
      }
    });*/


  }

  getDadosTreino(){
    const strings = this.state.strings;

    //-----
    const tipo_treino = this.getItemSelect({
      value: this.state.tipo_treino,
      arr: TIPOS_PLANILHA});

    const onde_treina = this.getItemSelect({
      value: this.state.onde_treina,
      arr: ONDE_TREINA});

    const qtd_dias = this.getItemSelect({
      value: this.state.qtd_dias,
      arr: DAYS});

    const tempo_musculacao = this.getItemSelect({
      value: this.state.tempo_musculacao,
      arr: TEMPO_MUSCULACAO});

    return (
      <form onSubmit={(e)=>this.iniciarApp(e)}>
        {/*<div className='block-sexo'>
          <div className='title-block-sexo'>Sexo*</div>
          <div className='pure-u-12-24'>
            <input
              checked={this.state.sexo==='F'}
              type='radio'
              value='F'
              name='sexo'
              onChange={this.handleInputChange}
            />
            <span className='sexo-txt'>Feminino</span>
          </div>
          <div className='pure-u-12-24'>
            <input
              checked={this.state.sexo==='M'}
              type='radio'
              value='M'
              name='sexo'
              onChange={this.handleInputChange}
            />
            <span className='sexo-txt'>Masculino</span>
          </div>
        </div>*/}
        <Select
          isSearchable={false}
          key={Math.random()}
          name='onde_treina'
          onChange={(e)=>this.handleSelect({name: 'onde_treina', value: e.value})}
          title={`${strings.txtOndeTreina}*`}
          options={ONDE_TREINA}
          value={onde_treina}
        />
        <Select
          isSearchable={false}
          key={Math.random()}
          name='qtd_dias'
          onChange={(e)=>this.handleSelect({name: 'qtd_dias', value: e.value})}
          title={`${strings.txtQuantidadeDias}*`}
          options={DAYS}
          value={qtd_dias}
        />
        {
          /*(!this.state.statusOt) ?
          <div>
            <Select
              isSearchable={false}
              key={Math.random()}
              name='tipo_treino'
              onChange={(e)=>this.handleSelect({name: 'tipo_treino', value: e.value})}
              title={`${strings.txtTipoTreino}*`}
              options={TIPOS_PLANILHA}
              value={tipo_treino}
            />
            <a href='#' onClick={this.openObjetivo} className='btObjetivo'>{strings.btObjetivo}</a>
          </div> : ''*/
          <div>
            <Select
              isSearchable={false}
              key={Math.random()}
              name='tipo_treino'
              onChange={(e)=>this.handleSelect({name: 'tipo_treino', value: e.value})}
              title={`${strings.txtTipoTreino}*`}
              options={TIPOS_PLANILHA}
              value={tipo_treino}
            />
            <a href='#' onClick={this.openObjetivo} className='btObjetivo'>{strings.btObjetivo}</a>
          </div>

        }

        <div  className="box-center-button">
          <Button type="submit" text="Entrar" classes="button-login simple-button" />
        </div>
      </form>
    );
  }

  render() {
    let tutorial = this.state.statusTutorial ? this.getTutorial() : null;
    const url = window.location.href;
    //se tiver ?ios=true na url apresentamos o tutorial ao usuário
    tutorial = (url.indexOf("?ios=true") > -1) ? tutorial : null;

    return (
      <div className="page-login" >
        {tutorial}
        <div className="wrapper-login">
          <div className="">
              <div className="box-form-login">
                <div className="box-login">
                  <div className="box-login--inner">
                    <div className="box-login-logo"><img src={LOGO} /></div>
                    <br />
                    <div className='img-beto-login'><img src={Beto} /></div>
                    {/* <div style={{padding: 50, textAlign: 'center'}}>
                      Treino gratuito encerrado.
                    </div> */}
                    { this.state.dadosTreino ? this.getDadosTreino() : this.getDadosLogin() }
                  </div>
                </div>
              </div>
              <div className=" beto-img-login">
                <img className="img-beto" src={BETO} />
              </div>
              <div className='clear'></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/classes/login/Login.js